import React, { useEffect, useState } from "react";
import tableData from "./variables/tableData.json";
import { columnsDataComplaints } from "./variables/columnsData";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ComplaintsTable from "./ComplaintTable";
import { useDispatch } from "react-redux";
import { getAllComplaints } from "../../../redux/action/index";
import { ConvertDateToEpoch } from "utils/functions";
const ComplaintList = (props) => {
  const [page, setPage] = useState(1);
  const [shimmer, setShimmer] = useState(false);
  const [complaintsData, setComplaintsData] = useState([]);
  // filter states
  const [complaintStatus, setComplaintStatus] = useState("");
  const [complaintType, setComplaintType] = useState("");
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // ---- //
  const dispatch = useDispatch();
  // const complaintsData = {
  //   data: [
  //     {
  //       subject: "Water Leakage in Building 4",
  //       location: "Building 4, Apartment 12",
  //       submission_date: 1694294400000, // 2024-09-10 00:00:00 in UTC
  //       natureOfComplaint: "Plumbing Issue",
  //       complaintStatus: "Pending",
  //       complaintType: "B & R",
  //       phoneNumber: "+971501234567",
  //       expectedDateToResolve: 1694712000000, // 2024-09-15 00:00:00 in UTC
  //     },
  //     {
  //       subject: "Electricity Fluctuation",
  //       location: "Building 8, Apartment 24",
  //       submission_date: 1694208000000, // 2024-09-09 00:00:00 in UTC
  //       natureOfComplaint: "Electrical Issue",
  //       complaintStatus: "In Progress",
  //       complaintType: "E & M",
  //       phoneNumber: "+971509876543",
  //       expectedDateToResolve: 1694546400000, // 2024-09-13 00:00:00 in UTC
  //     },
  //     {
  //       subject: "Broken Window",
  //       location: "Building 3, Apartment 5",
  //       submission_date: 1694121600000, // 2024-09-08 00:00:00 in UTC
  //       natureOfComplaint: "Maintenance Request",
  //       complaintStatus: "Resolved",
  //       complaintType: "B & R",
  //       phoneNumber: "+971501122334",
  //       expectedDateToResolve: 1694294400000, // 2024-09-10 00:00:00 in UTC
  //     },
  //     {
  //       subject: "Noisy Construction",
  //       location: "Building 9, Apartment 31",
  //       submission_date: 1694035200000, // 2024-09-07 00:00:00 in UTC
  //       natureOfComplaint: "Noise Complaint",
  //       complaintStatus: "Under Review",
  //       complaintType: "Miscellaneous",
  //       phoneNumber: "+971508765432",
  //       expectedDateToResolve: 1694457600000, // 2024-09-12 00:00:00 in UTC
  //     },
  //   ],
  // };
  let [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);
  };

  const handleGetComplaints = (page) => {
    setShimmer(true);

    dispatch(
      getAllComplaints({
        skip: (page - 1) * 10,
        limit: 10,
        search: search,
        startDate: ConvertDateToEpoch(startDate),
        endDate: ConvertDateToEpoch(endDate),
        sort: parseInt(sort),
        complaintType: complaintType,
        complaintStatus: parseInt(complaintStatus),
      })
    )
      .then((res) => {
        setComplaintsData(res?.data);
        setShimmer(false);
      })
      .catch((err) => {
        setComplaintsData([]);
        console.log("Get Err:", err);
        setShimmer(false);
      });
  };
  const resetFilters = () => {
    setComplaintStatus("");
    setComplaintType("");
    setSearch("");
    setSort("");
    setStartDate("");
    setEndDate("");
    setShimmer(true);
    dispatch(
      getAllComplaints({
        skip: (page - 1) * 10,
        limit: 10,
      })
    )
      .then((res) => {
        setComplaintsData(res?.data);
        setShimmer(false);
      })
      .catch((err) => {
        setComplaintsData([]);
        console.log("Get Err:", err);
        setShimmer(false);
      });
  };
  useEffect(() => {
    handleGetComplaints(page);
  }, [page]);
  return (
    <>
      <ComplaintsTable
        columnsData={columnsDataComplaints}
        handleGetAccounts={handleGetComplaints}
        tableData={[]}
        complaintsData={complaintsData}
        shimmer={shimmer}
        setShimmer={setShimmer}
        handleGetComplaints={handleGetComplaints}
        complaintStatus={complaintStatus}
        setComplaintStatus={setComplaintStatus}
        complaintType={complaintType}
        setComplaintType={setComplaintType}
        search={search}
        setSearch={setSearch}
        sort={sort}
        setSort={setSort}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        toggleDrawer={toggleDrawer}
        resetFilters={resetFilters}
      />
      {complaintsData?.count > 10 && (
        <div className="flex h-[50px] w-full items-center justify-center">
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(complaintsData?.count / 10) || 10}
              page={page}
              onChange={(e, page) => setPage(page)}
              variant="outlined"
              color="primary"
            />
          </Stack>
        </div>
      )}
    </>
  );
};

export default ComplaintList;
